import {memo} from "react";
import {Typography} from "@material-tailwind/react";

const TableSkeleton = () => {
    const columns = 4;
    const records = 6;

    const head:JSX.Element[] = [];
    const body:JSX.Element[] = [];
    for (let i = 0; i < columns; i++)
        head.push(<th className="w-[25%] py-2 px-1" key={'cols-'+i}>
            <Typography
                as="div"
                variant="paragraph"
                className="h-6 w-full rounded-full bg-gray-400 dark:bg-gray-600 text-4xl"
            >
                &nbsp;
            </Typography>
        </th>);

    for (let i=0; i<records; i++){
        body.push(<tr>{[...Array(columns)].map(() => <td className="w-[25%] py-2 px-1" key={'rrr-'+(i+columns+Math.random())}><Typography
            as="div"
            variant="paragraph"
            className="h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800 text-4xl"
        >
            &nbsp;
        </Typography></td>)}</tr>)
    }
    return <>
        <table className="w-full table-auto text-left animate-pulse">
            <thead>
            <tr>
                {head}
            </tr>
            </thead>
            <tbody>
            {body}
            </tbody>
        </table>
    </>
}

export default memo(TableSkeleton);
